import { Button } from "components/ui";
import React, { useState } from "react";
// React Hook Form compatibility pattern
let useForm: any, Controller: any;
try {
	const hookForm = require("react-hook-form");
	useForm = hookForm.useForm;
	Controller = hookForm.Controller;
} catch {
	// Fallback implementations if needed
	useForm = () => ({ register: () => {}, handleSubmit: (fn: any) => fn, formState: { errors: {} } });
	Controller = ({ render, ...props }: any) => render({ onChange: () => {}, onBlur: () => {}, value: '', name: props.name });
}
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { Radio, Space } from 'antd';
import { renderInput } from "components/FormComponents";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";
import { FileExcelOutlined } from "@ant-design/icons";

interface FormFields {
	name: string;
	type: string;
}

interface RenameShareLinkFormProps {
	handleRenameShareLink: (name: string) => void;
	shareLink: any;
}

const radioOptions = [
	{ label: 'Navigator', value: 'navigator' },
	{ label: 'Editor', value: 'editor' },
	// { label: 'vr', value: 'vr' }, VR stays part of editor sharelink as it has always been
];

const RenameShareLinkForm = ({ handleRenameShareLink, shareLink }: RenameShareLinkFormProps) => {
	const { control, handleSubmit, formState: { errors }, reset } = useForm({
		defaultValues: {
			name: (shareLink?.name as string) || ""
		},
	});

	const [loading, setLoading] = useState(false);

	const { t } = useTranslation();

	const onTypeChange = ({ target: { value } }: any) => {
		// console.log('radio changed', value);
		// setSharelinkType(value);
	};

	const onSubmit = async (tokenInfo: any) => {
		setLoading(true);
		await handleRenameShareLink(tokenInfo);
		setLoading(false);
		reset();
	};

	return (
		<StyledFormContainer>
			<StyledInputContainer>
				<Controller
					control={control}
					render={renderInput({
						placeholder: t("app.createToken.placeholder.name"),
					})}
					name="name"
					rules={{
						required: t("app.form.error.requiredField") as string,
					}}
					// value={}
				/>
				<FormErrorMessage name="name" errors={errors} />
			</StyledInputContainer>

			<Button
				style={{ marginTop: "20px" }}
				onClick={handleSubmit(onSubmit)}
				loading={loading}
				disabled // ={loading} TODO BE call not yet implemented
			>
				{String(t("app.global.btn.rename"))}
			</Button>
		</StyledFormContainer>
	);
};

const StyledFormContainer = styled.form`
	span {
		width: 100%;
	}
	.ant-radio {
		width: unset;
	}
	.ant-radio-inner {
		width: 17px;
		height: 16px;
	}
`;

const StyledInputContainer = styled.div`
	padding-top: 10px;
`;

export default RenameShareLinkForm;
